import axios from "axios";

export default {
  namespaced: true,

  state: {
    statistics: null,
    income: null,
    progress: null,
    msgError: null,
    periods: null,
    weeks: null
  },

  getters: {
    getStatistics: state => state.statistics,
    getIncome: state => state.income,
    getProgress: state => state.progress,
    getPeriods: state => state.periods,
    getMsgError: state => state.msgError,
    getWeeks: state => state.weeks
  },

  mutations: {
    SET_METRIC(state, data) {
      if (data.hasOwnProperty("statistics")) {
        state.statistics = data.statistics;
      }
      if (data.hasOwnProperty("income")) {
        state.income = data.income;
      }
    },
    SET_PROGRESS(state, data) {
      state.progress = data;
    },
    SET_MSG_ERROR(state, data) {
      state.msgError = data;
    },
    SET_PERIODS(state, data) {
      if (data.hasOwnProperty("periods")) {
        state.periods = data.periods;
      }
      if (data.hasOwnProperty("weeks")) {
        state.weeks = data.weeks;
      }
    }
  },

  actions: {
    async GET_METRIC(context, data) {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      await axios
        .get(`${endpoint}/catering/statistics`, {
          params: data
        })
        .then(response => {
          context.commit("SET_METRIC", response.data.detail);
        })
        .catch(error => console.log(error));
    },
    async GET_PROGRESS(context, data) {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      await axios
        .get(`${endpoint}/catering/progress`, {
          params: data
        })
        .then(response => {
          context.commit("SET_PROGRESS", response.data.detail);
        })
        .catch(err => {
          context.commit("SET_MSG_ERROR", err.response.data.message);
        });
    },
    async GET_PERIODS(context) {
      const endpoint = process.env.VUE_APP_API_CATERINGV2;
      await axios
        .get(`${endpoint}/catering/levels/time-cuts`)
        .then(response => {
          context.commit("SET_PERIODS", response.data.detail);
        })
        .catch(error => console.log(error));
    }
  }
};
